module.exports = __webpack_public_path__ + "img/title.08b6ac80.png";